function getFirstEightChars(inputString) {
  if (typeof inputString !== 'string' || inputString.length === 0) {
    return '';
  }
  if (inputString.length <= 8) {
    return inputString;
  }
  return inputString.substring(0, 8);
}

export default getFirstEightChars;
